import React from 'react';
import './StatusBadge.css';

/**
 * A reusable StatusBadge component for consistent status styling across the app.
 *
 * @param {Object} props
 * @param {string} props.status - The status string (e.g., 'A', 'Active', 'P', 'Pending', 'L', 'Locked').
 * @param {string} props.className - Additional custom class names.
 */
const StatusBadge = ({ status, className = '' }) => {
  const getStatusBadgeClass = (statusStr) => {
    if (!statusStr || (typeof statusStr !== 'string' && typeof statusStr !== 'number')) {
      return 'status-badge-total';
    }
    const upperStatus = statusStr.toString().toUpperCase();
    if (upperStatus === 'A' || upperStatus === 'ACTIVE') {
      return 'status-badge-active';
    } else if (upperStatus === '2') {
      return 'status-badge-active';
    } else if (upperStatus === 'P' || upperStatus === 'PENDING') {
      return 'status-badge-pending';
    } else if (upperStatus === '3') {
      return 'status-badge-pending';
    } else if (upperStatus === 'S' || upperStatus === 'SENT' || upperStatus === 'SUCCESS') {
      return 'status-badge-active';
    } else if (upperStatus === 'L' || upperStatus === 'LOCKED' || upperStatus === 'LOCK') {
      return 'status-badge-locked';
    } else if (upperStatus === '4') {
      return 'status-badge-locked';
    } else if (upperStatus === '1') {
      return 'status-badge-inactive';
    } else if (
      upperStatus === 'INACTIVE' ||
      upperStatus === 'I' ||
      upperStatus === 'I/A' ||
      upperStatus === 'IN/A' ||
      upperStatus === 'FAILED' ||
      upperStatus === 'ERROR'
    ) {
      return 'status-badge-inactive';
    } else {
      return 'status-badge-total';
    }
  };

  const getStatusDisplay = (statusStr) => {
    if (!statusStr || (typeof statusStr !== 'string' && typeof statusStr !== 'number')) {
      return 'N';
    }
    const upperStatus = statusStr.toString().toUpperCase();
    if (upperStatus === 'ACTIVE') return 'A';
    if (upperStatus === '2') return 'A';
    if (upperStatus === 'PENDING') return 'P';
    if (upperStatus === '3') return 'P';
    if (upperStatus === 'SENT' || upperStatus === 'SUCCESS') return 'S';
    if (upperStatus === 'LOCKED' || upperStatus === 'LOCK') return 'L';
    if (upperStatus === '4') return 'L';
    if (upperStatus === 'FAILED' || upperStatus === 'ERROR') return 'F';
    if (upperStatus === '1') return 'I';
    if (upperStatus === 'INACTIVE' || upperStatus === 'I' || upperStatus === 'I/A' || upperStatus === 'IN/A') return 'I';
    return upperStatus.charAt(0);
  };

  const badgeClass = `status-badge ${getStatusBadgeClass(status)} ${className}`.trim();

  return (
    <span className="status-badge-wrap">
      <span className={badgeClass}>
        {getStatusDisplay(status)}
      </span>
    </span>
  );
};

export default StatusBadge;
